import { PaperIcon, PostHiringInfoCard, UserIcon } from "@cpj-ai/panel-npm-package";
import { GetEmployeeByIdQuery } from "@graphql/generated";
import dayjs from "dayjs";

interface IStatisticsCardProps {
  data?: GetEmployeeByIdQuery;
}
const OverviewTabContent = ({ data }: IStatisticsCardProps) => {
  // const statisticsData = useMemo(() => {
  //   return [
  //     {
  //       icon: <Work2Icon className="w-6 h-6 fill-cyan-700 -mt-0.5" />,
  //       value: data?.organization?.employee?.get?.cooperations?.[0]?.startAt
  //         ? dayjs(data?.organization?.employee?.get?.cooperations?.[0]?.startAt).diff(
  //             data?.organization?.employee?.get?.cooperations?.[0]?.endAt || new Date(),
  //             "day",
  //           )
  //         : "0",
  //       label: "Cooperation Day",
  //       iconBgColor: "bg-cyan-800",
  //     },
  //     {
  //       icon: <BookIcon className="w-6 h-6 stroke-pink-500 -mt-0.5" />,
  //       value: "12",
  //       label: "Completed Trainings",
  //       iconBgColor: "bg-pink-600",
  //     },
  //     {
  //       icon: <ChartCircleIcon className="w-6 h-6 stroke-green-600 -mt-0.5" />,
  //       value: "87.2%",
  //       label: "Employer SatisfactionRate",
  //       iconBgColor: "bg-green-700",
  //     },
  //     {
  //       icon: <DocumentChartsIcon className="w-6 h-6 stroke-yellow-500 -mt-0.5" />,
  //       value: "3",
  //       label: "Monthly report",
  //       iconBgColor: "bg-yellow-600",
  //     },
  //   ];
  // }, []);

  return (
    <div>
      {/* <div className="flex gap-5">
        {statisticsData.map((item) => (
          <PostHiringStatisticsCard key={item.label} {...item} />
        ))}
      </div> */}

      <div className="flex flex-col gap-6">
        <PostHiringInfoCard
          icon={<UserIcon className="w-6 h-6 -mt-0.5" />}
          label="Personal information:"
          data={[
            { label: "First name :", value: data?.organization?.employee?.get?.employee?.firstName },
            { label: "Last name :", value: data?.organization?.employee?.get?.employee?.lastName },
            { label: "Gender :", value: data?.organization?.employee?.get?.employee?.profile?.gender },
            { label: "Date of birth :", value: data?.organization?.employee?.get?.employee?.profile?.birthDate },
            { label: "Country :", value: data?.organization?.employee?.get?.employee?.profile?.city?.country.name },
            { label: "Province :", value: data?.organization?.employee?.get?.employee?.profile?.city?.region?.name },
            { label: "City :", value: data?.organization?.employee?.get?.employee?.profile?.city?.name },
          ]}
        />
        <PostHiringInfoCard
          icon={<PaperIcon className="w-6 h-6 -mt-0.5" />}
          label="Contract information :"
          data={[
            {
              label: "Job Title :",
              value: data?.organization?.employee?.get?.cooperations?.[0]?.jobPosition?.title ?? "-",
            },
            {
              label: "Contract Type :",
              value:
                data?.organization?.employee?.get?.cooperations?.[0]?.jobPosition?.contractType
                  ?.replace("_", " ")
                  .toLocaleLowerCase() ?? "-",
            },
            {
              label: "Employment Status :",
              value: data?.organization?.employee?.get?.cooperations?.[0]?.status
                ?.replace("_", " ")
                .toLocaleLowerCase(),
            },
            {
              label: "Work Experience :",
              value: (() => {
                const startDate = data?.organization?.employee?.get?.cooperations?.[0]?.startAt;
                const endDate = data?.organization?.employee?.get?.cooperations?.[0]?.endAt || new Date();

                if (!startDate) return "-";

                const years = dayjs(endDate).diff(startDate, "year");
                const months = dayjs(endDate).subtract(years, "year").diff(startDate, "month");
                const days = dayjs(endDate).subtract(years, "year").subtract(months, "month").diff(startDate, "day");

                const parts = [];
                if (years > 0) parts.push(`${years} year${years !== 1 ? "s" : ""}`);
                if (months > 0) parts.push(`${months} month${months !== 1 ? "s" : ""}`);
                if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);

                return parts.length > 0 ? parts.join(" ") : "Less than a day";
              })(),
            },
            {
              label: "Hired date :",
              value: data?.organization?.employee?.get?.cooperations?.[0]?.createdAt
                ? dayjs(data?.organization?.employee?.get?.cooperations?.[0]?.createdAt).format("YYYY/MM/DD")
                : "-",
            },
            {
              label: "Start Date :",
              value: data?.organization?.employee?.get?.cooperations?.[0]?.startAt
                ? dayjs(data?.organization?.employee?.get?.cooperations?.[0]?.startAt).format("YYYY/MM/DD")
                : "-",
            },
            {
              label: "End Date :",
              value: data?.organization?.employee?.get?.cooperations?.[0]?.endAt
                ? dayjs(data?.organization?.employee?.get?.cooperations?.[0]?.endAt).format("YYYY/MM/DD")
                : "-",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default OverviewTabContent;
